import React, { useState } from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import websitelogo from '../../../../assets/logos/websitelogo.svg';
import MailOutlineOutlinedIcon from '@mui/icons-material/MailOutlineOutlined';
import CallIcon from '@mui/icons-material/Call';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import './Signup.css';
import {
	Alert,
	Box,
	Checkbox,
	CssBaseline,
	FormControlLabel,
	Grid,
	IconButton,
	InputAdornment,
	Modal,
	OutlinedInput,
	Snackbar,
	TextField,
	Typography,
} from '@mui/material';
import MaskedInput from 'react-text-mask';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import {
	LockOutlined,
	SecurityRounded,
	SupportAgentRounded,
	Visibility,
	VisibilityOff,
} from '@mui/icons-material';
import { useNavigate, Link } from 'react-router-dom';
import { register } from '../../../services/api/apiManager';
import * as Yup from 'yup';
import PrivacyPolicy from './PrivacyPolicy';

const style = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	// maxWidth: '500px',
	height: '85vh',
	overflow: 'auto',
	bgcolor: 'white',
	// border: '2px solid #000',
	// boxShadow: 24,
	borderRadius: '5px',
	padding: '10px 4px',
};

function Signup() {
	const defaultTheme = createTheme();
	const [openSnackbar, setOpenSnackbar] = useState(false);
	const [openSnackbarError, setOpenSnackbarError] = useState(false);
	const [passwordWrong, setPasswordWrong] = useState(false);
	const [passwordError, setPasswordError] = useState(false);
	const [emptyField, setEmptyFieldError] = useState(false);
	const [email, setEmail] = useState('');
	const [formSubmitted, setFormSubmitted] = React.useState(false);
	const [termsAccepted, setTermsAccepted] = useState(false);
	const [termsCondition, setTermsCondition] = useState(false);
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);

	const navigate = useNavigate();
	const handleSnackbarClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbar(false);
	};
	const handleSnackbaErrorClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setOpenSnackbarError(false);
		setPasswordWrong(false);
		setTermsCondition(false);
	};
	const handleSnackbaWrongClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setPasswordWrong(false);
	};
	const handlePasswordErrorClose = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setPasswordError(false);
	};
	const handleEmptyFieldError = (event, reason) => {
		if (reason === 'clickaway') {
			return;
		}
		setEmptyFieldError(false);
	};
	const navigateLogin = useNavigate();

	// const handleSignInClick = () => {
	// 	navigateLogin('/'); // Replace '/login' with the actual route of your Login page
	// };

	// const handleButtonClick = () => {
	// 	setOpenSnackbar(true);
	// };
	const handleLoginClick = () => {
		navigate('/');
	};
	const [showPassword, setShowPassword] = React.useState(false);
	const handleClickShowPassword = () => setShowPassword((show) => !show);
	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	const schema = Yup.object().shape({
		first_name: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'only alphabets'),
		last_name: Yup.string()
			.required('Required*')
			.matches(/^[a-zA-Z\s]+$/, 'only alphabets'),
		email: Yup.string().matches(
			/^[A-Za-z0-9]+[-A-Za-z0-9._]*@([-A-Za-z0-9]+[^@])+[A-Za-z]{2,5}$/,
			'Wrong Email'
		),
		UserContactNo: Yup.string().matches(
			/^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/,
			'Invalid '
		),
		password: Yup.string()
			.required('Password is required')
			.test(
				'special-character',
				'Password must contain at least one special character',
				(value) => /[!@#$%^&*(),.?":{}|<>]/.test(value)
			)
			.test(
				'numeric-character',
				'Password must contain at least one numeric character',
				(value) => /\d/.test(value)
			)
			.test(
				'alphabetic-character',
				'Password must contain at least five alphabetic characters',
				(value) => /[a-zA-Z].*[a-zA-Z].*[a-zA-Z]/.test(value)
			),
		confirmPassword: Yup.string()
			.required('Password is required')
			.test(
				'special-character',
				'Password must contain at least one special character',
				(value) => /[!@#$%^&*(),.?":{}|<>]/.test(value)
			)
			.test(
				'numeric-character',
				'Password must contain at least one numeric character',
				(value) => /\d/.test(value)
			)
			.test(
				'alphabetic-character',
				'Password must contain at least five alphabetic characters',
				(value) => /[a-zA-Z].*[a-zA-Z].*[a-zA-Z]/.test(value)
			),
	});
	const handleChange = (event) => {
		debugger;
		const { name, value } = event.target;
		setFormData({ ...formData, [name]: value });
	};
	const [errors, setErrors] = useState({});

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		setFormData((prev) => ({
			...prev,
			[name]: value,
		}));

		Yup.reach(schema, name)
			.validate(value)
			.then(() => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: '', // Clear error if validation passes
				}));
			})
			.catch((error) => {
				setErrors((prevErrors) => ({
					...prevErrors,
					[name]: error.message, // Set error message if validation fails
				}));
			});
	};

	const [formData, setFormData] = useState({
		is_staff: 'true',
		first_name: '',
		last_name: '',
		email: '',
		UserContactNo: '',
		password: '',
		confirmPassword: '',
	});
	const handleSignup = async () => {
		try {
			debugger;
			event.preventDefault();
			setFormSubmitted(true);

			if (Object.values(formData).some((value) => value === '')) {
				setEmptyFieldError(true);
				return; // Exit function if any field is empty
			}
			// Check if passwords match
			if (formData.password !== formData.confirmPassword) {
				setPasswordError(true);
				return; // Exit function if passwords don't match
			}
			if (!termsAccepted) {
				setTermsCondition(true);
				return; // Do not proceed if terms are not accepted
			}
			// Validate the entire form
			await schema.validate(formData, { abortEarly: false });

			const res = await register(formData);
			// Handle response as needed
			if (res?.status === 201) {
				setOpenSnackbar(true);
				// Optionally, redirect to login page or show success message
				setTimeout(() => {
					navigate('/verification');
				}, 1500);
			} else if (
				res?.response?.data?.msg ==
				"Error in RegisterUser post: {'email': [ErrorDetail(string='user with this Email Address already exists.', code='unique')]}"
			) {
				// If email already exists
				setOpenSnackbarError(true);
			} else {
				setPasswordWrong(true);
			}
		} catch (error) {
			// Handle error
		}
	};
	// const handleChange = (event) => {
	// 	const { name, value } = event.target;
	// 	setFormData({ ...formData, [name]: value });
	// };
	const handleCheckboxChange = (event) => {
		setTermsAccepted(event.target.checked);
	};
	return (
		<ThemeProvider theme={defaultTheme}>
			<Grid
				container
				component="main"
				className="signup-page"
				sx={{
					height: '100vh',
					backgroundImage: `url(${require('../../../../assets/images/Authentication-bg.webp')})`,
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					backgroundPosition: 'center',
					display: 'flex',
					justifyContent: 'center',
					alignItems: 'center',
					padding: '28px 36px',
					'@media (max-width: 600px)': {
						padding: '14px',
					},
				}}
			>
				<CssBaseline />
				<Grid
					container
					item
					justifyContent="center"
					className="signup-shell"
					sx={{
						maxWidth: '1060px',
						borderRadius: '24px',
						overflow: 'hidden',
						boxShadow: '0 28px 70px rgba(74, 95, 132, 0.22)',
						backgroundColor: 'rgba(255,255,255,0.68)',
						border: '1px solid rgba(255,255,255,0.72)',
						backdropFilter: 'blur(8px)',
					}}
				>
					<Grid
						item
						xs={false}
						sm={6}
						md={6}
						lg={5.5}
						xl={5.5}
						className="signup-brand-panel"
						sx={{
							display: 'flex',
							flexDirection: 'column',
							justifyContent: 'center',
							minHeight: '610px',
							display: { sm: 'none', xs: 'none', md: 'flex' },
						}}
					>
						<Box className="signup-brand-logo">
						</Box>
						<Box className="signup-brand-copy">
							<Typography className="signup-brand-title">
								Create your MaxCharts account
							</Typography>
							<Box className="signup-brand-accent" />
							<Typography className="signup-brand-subtitle">
								Start with a clean, connected workspace for doctors, patients,
								and billing teams.
							</Typography>
						</Box>
						<Box className="signup-brand-footer">
							<Box className="signup-feature-card">
								<Box className="signup-feature-icon">
									<SupportAgentRounded />
								</Box>
								<Box>
								<Typography className="signup-feature-title">
									Fast onboarding
								</Typography>
								<Typography className="signup-feature-text">
									Set up your team and get into the workflow quickly.
								</Typography>
								</Box>
							</Box>
							<Box className="signup-feature-divider" />
							<Box className="signup-feature-card">
								<Box className="signup-feature-icon">
									<SecurityRounded />
								</Box>
								<Box>
								<Typography className="signup-feature-title">
									Protected data
								</Typography>
								<Typography className="signup-feature-text">
									Your account and patient operations stay organized and secure.
								</Typography>
								</Box>
							</Box>
						</Box>
						<Box className="signup-links-row">
							<Box className="signup-link-item">
								<ContactSupportIcon className="signup-link-icon" />
								<Link to={'/aboutUs'} className="signup-side-link">
									<Typography>About Us</Typography>
								</Link>
							</Box>
							<Box className="signup-link-item">
								<CallIcon className="signup-link-icon" />
								<Link to={'/contactUs'} className="signup-side-link">
									<Typography>Contact Us</Typography>
								</Link>
							</Box>
						</Box>
					</Grid>
					<Grid
						component={Paper}
						square
						item
						xs={12}
						sm={12}
						md={6}
						lg={6.5}
						xl={6.5}
						className="signup-form-panel"
						sx={{
							background: 'rgba(255,255,255,0.96)',
							'@media (max-width: 600px)': {
								minHeight: 'auto',
							},
							overflow: 'auto',
						}}
					>
						<Box className="signup-form-wrap">
							<Box className="signup-form-logo">
								<img
									src={websitelogo}
									alt="MaxCharts"
									style={{
										width: '190px',
										height: 'auto',
										objectFit: 'contain',
									}}
								/>
							</Box>
							<Typography component="h1" variant="h5" className="signup-form-title">
								Sign Up
							</Typography>
							<Typography className="signup-form-subtitle">
								Create your account to get started
							</Typography>
							<Box component="form" className="signup-form">
								<Grid container spacing={1.5}>
									<Grid item xs={12} sm={6}>
										<Typography variant="body2" className="signup-field-label">
											First Name
										</Typography>
										<OutlinedInput
											className="signup-input"
											fullWidth
											type="text"
											name="first_name"
											value={formData.first_name}
											onChange={handleInputChange}
											required
											id="first_name"
											placeholder="Enter first name"
											startAdornment={
												<InputAdornment position="start">
													<PersonOutlineOutlinedIcon className="signup-input-icon" />
												</InputAdornment>
											}
										/>
										{errors.first_name && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.first_name}
											</div>
										)}{' '}
										{/* Display validation error */}
									</Grid>
									<Grid item xs={12} sm={6}>
										<Typography variant="body2" className="signup-field-label">
											Last Name
										</Typography>
										<OutlinedInput
											className="signup-input"
											fullWidth
											type="text"
											name="last_name"
											value={formData.last_name}
											onChange={handleInputChange}
											required
											id="last_name"
											placeholder="Enter last name"
											startAdornment={
												<InputAdornment position="start">
													<PersonOutlineOutlinedIcon className="signup-input-icon" />
												</InputAdornment>
											}
										/>
										{errors.last_name && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.last_name}
											</div>
										)}{' '}
										{/* Display validation error */}
									</Grid>
								</Grid>
								<Typography variant="body2" className="signup-field-label">
									Email Address
								</Typography>
								<OutlinedInput
									className="signup-input"
									fullWidth
									type="email"
									name="email"
									inputProps={{
										autoComplete: 'email',
									}}
									value={formData.email}
									onChange={handleInputChange}
									autoComplete="email"
									required
									id="email"
									placeholder="Enter your email address"
									startAdornment={
										<InputAdornment position="start">
											<MailOutlineOutlinedIcon className="signup-input-icon" />
										</InputAdornment>
									}
								/>
								{errors.email && (
									<div style={{ color: 'red', fontSize: '10px' }}>
										{errors.email}
									</div>
								)}{' '}
								{/* Display validation error */}
								<Typography variant="body2" className="signup-field-label">
									Contact No:
								</Typography>
								<TextField
									className="signup-textfield"
									variant="outlined"
									fullWidth
									required
									name="UserContactNo"
									value={formData.UserContactNo}
									onChange={handleChange}
									InputProps={{
										startAdornment: (
											<InputAdornment position="start">
												<CallIcon className="signup-input-icon" />
											</InputAdornment>
										),
										inputComponent: MaskedInput,
										inputProps: {
											mask: [
												'(',
												/\d/,
												/\d/,
												/\d/,
												')',
												' ',
												/\d/,
												/\d/,
												/\d/,
												'-',
												/\d/,
												/\d/,
												/\d/,
												/\d/,
											],
										},
									}}
								/>
								{/* Display validation error */}
								<Grid container spacing={1.5}>
									<Grid item xs={12} sm={6}>
										<Typography variant="body2" className="signup-field-label">
											Password
										</Typography>
										<OutlinedInput
											className="signup-input"
											fullWidth
											required
											name="password"
											value={formData.password}
											onChange={handleInputChange}
											id="password"
											autoComplete="current-password"
											placeholder="Enter password"
											type={showPassword ? 'text' : 'password'}
											startAdornment={
												<InputAdornment position="start">
													<LockOutlined className="signup-input-icon" />
												</InputAdornment>
											}
											endAdornment={
												<InputAdornment position="end">
													<IconButton
														aria-label="toggle password visibility"
														onClick={handleClickShowPassword}
														onMouseDown={handleMouseDownPassword}
														edge="end"
														sx={{ color: '#8a95ad' }}
													>
														{showPassword ? <VisibilityOff /> : <Visibility />}
													</IconButton>
												</InputAdornment>
											}
										/>
										{errors.password && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.password}
											</div>
										)}{' '}
										{/* Display validation error */}
									</Grid>
									<Grid item xs={12} sm={6}>
										<Typography variant="body2" className="signup-field-label">
											Confirm Password
										</Typography>
										<OutlinedInput
											className="signup-input"
											fullWidth
											required
											name="confirmPassword"
											value={formData.confirmPassword}
											onChange={handleInputChange}
											id="confirmPassword"
											autoComplete="current-password"
											type={showPassword ? 'text' : 'password'}
											placeholder="Confirm password"
											startAdornment={
												<InputAdornment position="start">
													<LockOutlined className="signup-input-icon" />
												</InputAdornment>
											}
											endAdornment={
												<InputAdornment position="end">
													<IconButton
														aria-label="toggle password visibility"
														onClick={handleClickShowPassword}
														onMouseDown={handleMouseDownPassword}
														edge="end"
														sx={{ color: '#8a95ad' }}
													>
														{showPassword ? <VisibilityOff /> : <Visibility />}
													</IconButton>
												</InputAdornment>
											}
										/>
										{errors.confirmPassword && (
											<div style={{ color: 'red', fontSize: '10px' }}>
												{errors.confirmPassword}
											</div>
										)}{' '}
										{/* Display validation error */}
									</Grid>
								</Grid>
								<Box className="signup-terms-row">
									<FormControlLabel
										className="signup-terms-label"
										control={
											<Checkbox
												sx={{
													color: '#2e73c9',
													'&.Mui-checked': {
														color: '#2e73c9',
													},
												}}
											checked={termsAccepted}
											onChange={handleCheckboxChange}
											color="primary"
											/>
										}
										label={
											<Typography className="signup-terms-text">
												I accept the terms and{' '}
												<span onClick={handleOpen} className="signup-terms-link">
													privacy policy
												</span>
											</Typography>
										}
									/>
								</Box>
								<Button
									variant="contained"
									fullWidth
									className="signup-submit"
									sx={{
										background: '#e87511',
										borderRadius: '10px',
										height: '44px',
										fontFamily: 'Poppins',
										fontSize: '14px',
										fontWeight: '600',
										marginTop: '4px',
										marginBottom: '14px',
										'&:hover': {
											background: '#e87511',
										},
									}}
									onClick={() => handleSignup()}
								>
									Sign Up
								</Button>
								<Box className="signup-divider-row">
									<Box className="signup-divider-line" />
									<Box className="signup-divider-badge">or</Box>
									<Box className="signup-divider-line" />
								</Box>
								<Box className="signup-login-row">
									<Typography className="signup-login-text">
										Already have an account?
									</Typography>
									<Link to={'/'} className="signup-login-link">
										<Typography>Login</Typography>
									</Link>
								</Box>
							</Box>
						</Box>
					</Grid>
				</Grid>
				{/* snack bars */}
				{/* snack bar for Email Exists */}
				<Snackbar
					open={openSnackbarError}
					autoHideDuration={6000} // Adjust the duration as needed
					onClose={handleSnackbaErrorClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbaErrorClose}
						severity="error"
						sx={{
							backgroundColor: 'red',
							fontSize: '17px',
							color: 'white',
							fontFamily: 'Poppins',
							padding: '15px',
							'& .MuiAlert-icon': {
								color: 'white', // Change icon color to white
							},
						}}
					>
						Email already exists.....
					</Alert>
				</Snackbar>
				{/* snack bar for other Error */}
				<Snackbar
					open={passwordWrong}
					autoHideDuration={1500} // Adjust the duration as needed
					onClose={handleSnackbaWrongClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbaWrongClose}
						severity="error"
						sx={{
							backgroundColor: 'red',
							fontSize: '17px',
							color: 'white',
							fontFamily: 'Poppins',
							padding: '15px',
							'& .MuiAlert-icon': {
								color: 'white', // Change icon color to white
							},
						}}
					>
						Something went Wrong
					</Alert>
				</Snackbar>
				{/* snack bar for empty field  */}
				<Snackbar
					open={emptyField}
					autoHideDuration={6000} // Adjust the duration as needed
					onClose={handleEmptyFieldError}
					anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				>
					<Alert
						onClose={handleEmptyFieldError}
						severity="error"
						sx={{
							backgroundColor: 'red',
							fontSize: '17px',
							color: 'white',
							fontFamily: 'Poppins',
							padding: '15px',
							'& .MuiAlert-icon': {
								color: 'white', // Change icon color to white
							},
						}}
					>
						Fill all the Fields
					</Alert>
				</Snackbar>
				{/* snack bar for Terms and Conditions  */}
				<Snackbar
					open={termsCondition}
					autoHideDuration={2000} // Adjust the duration as needed
					onClose={handleSnackbaErrorClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbaErrorClose}
						severity="error"
						sx={{
							backgroundColor: 'red',
							fontSize: '17px',
							color: 'white',
							fontFamily: 'Poppins',
							padding: '15px',
							'& .MuiAlert-icon': {
								color: 'white', // Change icon color to white
							},
						}}
					>
						Please Accept Terms & Conditions
					</Alert>
				</Snackbar>
				{/* snack bar for password not matched  */}
				<Snackbar
					open={passwordError}
					autoHideDuration={6000} // Adjust the duration as needed
					onClose={handlePasswordErrorClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handlePasswordErrorClose}
						severity="error"
						sx={{
							backgroundColor: 'red',
							fontSize: '17px',
							color: 'white',
							fontFamily: 'Poppins',
							padding: '15px',
							'& .MuiAlert-icon': {
								color: 'white', // Change icon color to white
							},
						}}
					>
						Password not Matched
					</Alert>
				</Snackbar>
				{/* Snackbar for account created  */}
				<Snackbar
					open={openSnackbar}
					autoHideDuration={6000} // Adjust the duration as needed
					onClose={handleSnackbarClose}
					anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				>
					<Alert
						onClose={handleSnackbarClose}
						severity="success"
						sx={{
							backgroundColor: '#3EAE4D',
							fontSize: '20px',
							padding: '15px',
							'& .MuiAlert-icon': {
								color: 'white', // Change icon color to white
							},
						}}
					>
						Account has been created! You may{' '}
						<span
							onClick={handleLoginClick}
							style={{
								cursor: 'pointer',
								textDecoration: 'underline',
								color: 'white',
							}}
						>
							LOG IN
						</span>
					</Alert>
				</Snackbar>

				{/* Terms and privacy modal */}
				<Modal
					open={open}
					// onClose={handleClose}
					aria-labelledby="modal-modal-title"
					aria-describedby="modal-modal-description"
				>
					<Box sx={style}>
						<Typography id="modal-modal-description">
							<PrivacyPolicy />
						</Typography>
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'flex-end',
								right: 25,
								paddingBottom: '15px',
							}}
						>
							<Button variant="outlined" onClick={() => setOpen(false)}>
								ok
							</Button>
						</Box>
					</Box>
				</Modal>
			</Grid>
		</ThemeProvider>
	);
}

export default Signup;
